var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "left-bar",
      attrs: { absolute: "", "mobile-breakpoint": "1024" },
      model: {
        value: _vm.menu,
        callback: function($$v) {
          _vm.menu = $$v
        },
        expression: "menu"
      }
    },
    [
      _c(
        "div",
        { staticClass: "left-bar__logo" },
        [
          _c("h2", [_vm._v("Logo")]),
          _vm._v(" "),
          _c("v-text-field", {
            staticClass: "search",
            attrs: {
              label: "Search",
              "prepend-inner-icon": "mdi-file-search-outline",
              solo: "",
              "hide-details": ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-list",
        [
          _c(
            "v-list-item",
            { attrs: { link: "", to: "/home" } },
            [
              _c("v-list-item-icon", [_c("v-icon", [_vm._v("mdi-home")])], 1),
              _vm._v(" "),
              _c("v-list-item-title", [_vm._v("Products")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            { attrs: { link: "", to: "/orders" } },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("mdi-format-list-bulleted")])],
                1
              ),
              _vm._v(" "),
              _c("v-list-item-title", [_vm._v("Orders")])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list-item",
            { attrs: { link: "", to: "/orders" } },
            [
              _c(
                "v-list-item-icon",
                [_c("v-icon", [_vm._v("mdi-account-cog")])],
                1
              ),
              _vm._v(" "),
              _c("v-list-item-title", [_vm._v("Settings")])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }